import MenuWrapper from "../../components/Product/MenuWrapper";

export default function index() {
    return (
        <div>
            <MenuWrapper />
        </div>
    )
}